import App from './app.vue';

export default App;
